import { render, staticRenderFns } from "./SemanticGraph.vue?vue&type=template&id=3958cd5a&scoped=true&"
import script from "./SemanticGraph.vue?vue&type=script&lang=js&"
export * from "./SemanticGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3958cd5a",
  null
  
)

export default component.exports